import React from "react";
import cx from "clsx";
import { getPathParams } from "../../utils/utils";
import { useClientQuery } from "../../../../../api/queries/useClientQuery";
import styles from "./ClientCherryInfo.module.scss";
import { capitalizeFirstLetter, showFormattedDate } from "../../../../../Utils";

export function ClientCherryInfo() {
  const { clientId } = getPathParams();
  const { data: clientData } = useClientQuery({ clientId });

  const preapprovalStatus = clientData?.cherryInfo?.preapprovalStatus || "";
  const creditLimit = clientData?.cherryInfo?.creditLimit || "";
  const creditExpiresAt = clientData?.cherryInfo?.creditExpiresAt || "";

  const noCherryInfo = !preapprovalStatus && !creditLimit && !creditExpiresAt;

  if (noCherryInfo) {
    return null;
  }

  return (
    <div className={cx(styles.cherryInfoWrapper, "col-xs-12")}>
      {preapprovalStatus && (
        <div>
          <div className={styles.title}>Cherry Preapproval Status</div>
          <div className={styles.itemText}>
            {capitalizeFirstLetter(preapprovalStatus) || ""}
          </div>
        </div>
      )}
      {creditLimit && (
        <div>
          <div className={styles.title}>Cherry Credit Limit </div>
          <div className={styles.itemText}>{creditLimit || ""}</div>
        </div>
      )}
      {creditExpiresAt && (
        <div>
          <div className={styles.title}>Cherry Credit Expires at </div>
          <div className={styles.itemText}>
            {showFormattedDate(creditExpiresAt) || ""}
          </div>
        </div>
      )}
    </div>
  );
}
